import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/qm-cockpit`;
export const de = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join(".") : "–");
export const dt = (iso) => (iso ? new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "–");
export const heute = () => new Date().toISOString().slice(0, 10);
export const fehler = (e) => toast.error(e?.response?.data?.detail || "Fehler");
export const feld = "w-full rounded-md border border-[#E0D6CA] bg-white px-2.5 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#9A3B2E]/30";

export const oeffnen = async (pfad, name) => {
  const r = await axios.get(`${API}${pfad}`, { responseType: "blob" }).catch(fehler);
  if (!r) return;
  const url = URL.createObjectURL(r.data);
  if (name) { const a = document.createElement("a"); a.href = url; a.download = name; a.click(); } else window.open(url, "_blank");
};

export const Frist = ({ frist, erledigt }) => {
  const ueber = !erledigt && frist && frist < heute();
  return <span className={ueber ? "text-[#C2452F] font-semibold" : "text-[#78716c]"}>{de(frist)}{ueber && " · überfällig"}</span>;
};

export const Badge = ({ children, ton = "grau", testid }) => {
  const t = { grau: "bg-[#F5F0EB] text-[#78716c]", gruen: "bg-[#E7EFE5] text-[#4F6650]", rot: "bg-[#FBE9E4] text-[#9A3B2E]", gelb: "bg-[#FBF1DC] text-[#8A6116]" }[ton];
  return <span data-testid={testid} className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${t}`}>{children}</span>;
};
